package com.dwarshb.bms

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime


class Utils {

    companion object {
        fun currentTime(): String {
            val datetime = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
            val hour = if (datetime.hour < 10) "0${datetime.hour}" else datetime.hour
            val minute = if (datetime.minute < 10) "0${datetime.minute}" else datetime.minute
            return "${datetime.dayOfMonth}-${datetime.month.name}-${datetime.year}/${hour}:${minute}"
        }

        fun getDate(milliseconds: Long): String {
            println(milliseconds)
            val date = Instant.fromEpochMilliseconds(milliseconds).toLocalDateTime(TimeZone.UTC)
            val day = if (date.dayOfMonth < 10) "0${date.dayOfMonth}" else date.dayOfMonth
            return "${day}-${date.month.name}-${date.year}"
        }

        fun getQueryParameter(url: String, key: String): String? {
            val query = url.substringAfter('?', "")
            return query.split('&')
                .map { it.split('=') }
                .firstOrNull { it.firstOrNull() == key }
                ?.getOrNull(1)
        }
    }
}